import React from 'react'
import Header from './Header';
import About from './About';

const FirstPage = () => {
    return (
        <section id="firstPage"  className="firstPage">
            <Header />
            <About />
        </section>
    )
}

export default FirstPage